/* eslint-disable @typescript-eslint/no-unused-vars */
import { useColorMode, useTheme } from '@tonic-one/react';
export const useDlpConditionStatementStyle = () => {
  const [colorMode] = useColorMode();
  const { colors } = useTheme();
  const hoverBackgroundColor = {
    dark: 'rgba(255, 255, 255, 0.12)',
    light: 'rgba(0, 0, 0, 0.12)',
  }[colorMode];
  const cellHeight = 36;
  const headerHeight = 36;
  const rowsToDisplay = 8;
  const rowsToDisplayWithMip = 18;
  const footerHeight = 16;

  const tableStyleProps = {
    height: headerHeight + rowsToDisplay * cellHeight,
    // Uncomment the following line to specify the width and enable horizontal scrollbar
    // width: 200,
  };
  const tableStylePropsWithMip = {
    height: headerHeight + rowsToDisplayWithMip * cellHeight + footerHeight,
  };

  // Sync the scroll position of the table header and table body for horizontal scrolling
  const tableHeaderStyleProps = {
    overflow: 'hidden',
  };
  const flexContianerColor = {
    light: colors['gray:60'],
    dark: colors['gray:60'],
  }[colorMode];
  const flexContianerStyle = {
    appearance: 'none',
    border: '0.0625rem solid',
    outline: 0,
    position: 'relative',
    transition: 'all .2s',
    borderRadius: '3px',
    fontSize: '14px',
    lineHeight: '20px',
    paddingLeft: '12px',
    paddingRight: '12px',
    paddingTop: '12px',
    paddingBottom: '5px',
    // width: '100%',
    backgroundColor: 'transparent',
    borderColor: flexContianerColor,
    overflow: 'auto',
  };
  return {
    hoverBackgroundColor,
    tableStyleProps,
    tableStylePropsWithMip,
    tableHeaderStyleProps,
    flexContianerStyle,
  };
};
